import OutgoingPayGateReversalPayment from "../entities/outgoingPayGateReversalPayment";
import type OutgoingPayGateReversalPaymentsRequest from "../entities/outgoingPayGateReversalPaymentsRequest";
import RepositoryBase from "./repositoryBase";
import type BackOfficeConnector from "../data/backOfficeConnector";
import type EventBus from "../services/eventBus";
import type { IPagination } from "../data/types";
import { serializeFilters } from "../utils/filters";

export default class OutgoingPaygateReversalRepository extends RepositoryBase<BackOfficeConnector> {
  constructor(protected apiFactory: ReturnType<typeof BackOfficeConnector.Factory>, protected eventBus: EventBus) {
    super(apiFactory, eventBus);
  }

  getAllOutgoingPaygateReversalsPayments(
    pagination: IPagination,
    filters: OutgoingPayGateReversalPaymentsRequest,
    abortSignal: AbortSignal
  ) {
    return this.callApi(api =>
      api
        .all("finance")
        .all("outgoing_paygate_reversal_payments")
        .postPagedEntities<OutgoingPayGateReversalPayment>(
          serializeFilters(filters, false),
          OutgoingPayGateReversalPayment,
          abortSignal,
          pagination
        )
    );
  }

  getAllOutgoingPaygatePaymentsExport(filters: OutgoingPayGateReversalPaymentsRequest) {
    return this.callApi(api =>
      api.all("finance").all("outgoing_paygate_reversal_payments").all("report").postOnly(serializeFilters(filters, false))
    );
  }
}
